import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api'
import Spinner from 'components/UI/Spinner';
import i18n from 'helpers/i18n'
// import Prettyfier from 'components/UI/Prettyfier';
// import HomeMember from './HomeMember';
// import HomeSpeaker from './HomeSpeaker';
import Header from '../Header/Header';
import Footer from '../Footer';
import OrderForm from './OrderForm';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Dialog from 'components/UI/Dialog/Dialog'
import Paragrapher from "components/UI/Paragrapher/Paragrapher";
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
// import { Redirect } from 'react-router-dom'
import {
  withStyles
} from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom'
import {
  fetchData,
  getDataHome,
  getLoadingError,
} from '../../ducks/asyncFetcher';
// import {
//   // isLoggedIn,
//   // getCurrentUserRole,
//   getCurrentUser,
// } from 'components/UI/Account/ducks/authentication';

const AF_KEY = 'home';

const styles = (theme) => {
  return {
    root: {
      color: '#222',
      fontSize: '1.2rem',
    },
    mainBlock: {
      maxWidth: 800,
      marginTop: theme.spacing(3),
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      marginBottom: theme.spacing(2),
      '& .MuiTypography-body1': {
        color: 'inherit',
        textAlign: 'left'
      },
      '& .MuiTypography-h2': {
        // margin: '0 auto',
        color: 'inherit',
        fontSize: '1.4rem',
        textAlign: 'left',
        marginBottom: theme.spacing(2),
      },
      '& .MuiTypography-body2': {
        // margin: '0 auto',
        color: 'inherit',
        fontSize: '1.4rem',
        textAlign: 'left',
        marginBottom: theme.spacing(2),
      },
      '& .MuiTypography-h3': {
        // margin: '0 auto',
        color: '#fff',
        fontWeight: 'bold',
        padding: theme.spacing(1),
        fontSize: '1.4rem',
        textAlign: 'left',
        backgroundColor: theme.palette.primary.main,
        marginBottom: theme.spacing(2)
      }

    },
    bullet: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: theme.spacing(2),
      width: '3rem',
      height: '3rem',
      lineHeight: '3rem',
      backgroundColor: '#eee',
      borderRadius: 180,
      textAlign: 'center',
      // fontSize: '2rem',
      fontWeight: 'bold'
    },

    bulletHuge: {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: theme.spacing(2),
      width: '3.5rem',
      height: '3.5rem',
      lineHeight: '5rem',
      backgroundColor: '#eee',
      borderRadius: 180,
      textAlign: 'center',
      // fontSize: '2rem',
      fontWeight: 'bold'
    },

    arrow: {
      fontSize: '5rem',
      color: '#eee'
    },
    processHelp: {
      marginTop:theme.spacing(6),
      marginBottom:theme.spacing(6),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      backgroundColor: '#fff',
      boxShadow: theme.shadows[4],
      borderRadius: 20
    },
    orderForm: {
      marginTop: theme.spacing(2)
    }
  }
}

const HeaderStyled = withStyles((theme) => {
  return {
    root: {
      paddingLeft: 0,
      paddingRight: 0,
      backgroundImage: 'url('+require('assets/images/header_registration.jpg')+')'
    },
    wrapper: {
      paddingTop: theme.spacing(4),
      paddingLeft: 0,
      paddingRight: 0
    },
    headerTitle: {
      paddingBottom: theme.spacing(2),
      '& .MuiTypography-h1': {
        marginTop: theme.spacing(6),
        paddingBottom: theme.spacing(18),
        fontWeight: 'normal',
        marginBottom: '0'
      }
    }
  }
})(Header);
class Home extends Component {
  constructor(props)
  {
    super(props);
    this.state = {dialogOpen: false}
  }
  componentDidMount() {
    this.props.onMount();
    // console.log('mount home')
  }

  componentDidUpdate(oldProps) {
  }

  _onFormComplete = () => {
    this.setState({dialogOpen: true})
  }
  _onFormError = () => {
    this.setState({dialogOpen: true})
  }
  _closePopin = () => {
    this.setState({dialogOpen: false})
  }
  render() {
    const { $$data, classes } = this.props;
    const {dialogOpen} = this.state;
    return (<div className={classes.root}>
    <HeaderStyled current="home" headerTitle={i18n.get('homeHeaderTitle', {pretty: true})} showMenu={false}/>
    <ScrollToTopOnMount />
    <Choose>
      <When condition={$$data !== undefined }>
        <Box className={classes.mainBlock}>
          <Typography variant="h2" gutterBottom>{i18n.get('homeContentTitle', {pretty: true})}</Typography>
          <Typography variant="body2" gutterBottom>{i18n.get('homeContentSubTitle', {pretty: true})}</Typography>

          <Box className={classes.processHelp}>
            <Grid container alignItems={'center'}>
              <Grid item xs={12} sm={5} container alignItems={'center'}>
                <span className={classes.bullet}>1</span> {i18n.get('homeProcessText1', {pretty: true, element: 'span', elementStyle: {display: 'inline-block', verticalAlign: 'top', width: 'calc(100% - 10rem)', textAlign: 'left'}})}
                <DoubleArrowIcon className={classes.arrow}/>
              </Grid>
              <Grid item xs={12} sm={7} container alignItems={'center'}>
                <span className={classes.bullet}>2</span> {i18n.get('homeProcessText2', {pretty: true, element: 'span', elementStyle: {display: 'inline-block', verticalAlign: 'top', width: 'calc(100% - 10rem)', textAlign: 'left'}})}
                <MailOutlineIcon className={classes.arrow}/>
              </Grid>
            </Grid>
          </Box>

          <Box className={classes.orderForm}>
            <Typography variant="h3">Formulaire de commande</Typography>
            <OrderForm onFormComplete={this._onFormComplete}/>
          </Box>

          <Dialog open={dialogOpen} showClose={true} title={false} titleStyle={{fontSize: '2rem'}} paperClassName={classes.paperClassName}>
            <Box width="100%" pb={3}>

            <Typography variant="body1" color="primary" style={{fontSize: '1.4rem', textAlign:'center', color: 'green'}} gutterBottom component="div"><CheckCircleIcon className={classes.bulletHuge} /> <Paragrapher text={"Votre commande a bien été prise en compte. "} prettyfy={true} elementStyle={{display: 'inline-block', verticalAlign: 'middle', fontSize: '1.7rem', width: 'calc(100% - 8rem)', textAlign: 'left', lineHeight: '2.2rem'}}/> </Typography>
            <Typography variant="body1" color="primary" style={{fontSize: '1.4rem', textAlign:'center', lineHeight: '1.8rem'}} component="div"><Paragrapher text={"Nous la traitons dans les plus bref délais pour procéder à l’envoi par courrier des modèles de démonstration."} prettyfy={true}/> </Typography>
            <img src={require('assets/images/modeldemo.png')} style={{maxWidth: '90%', marginLeft: 'auto', marginRight: 'auto', display: 'block', marginTop: '16px'}} alt="logo"/>
            <Box pt={3} width="100%" align="center">
              <Button size="large" color="primary" variant="contained" onClick={this._closePopin}>Fermer</Button>
            </Box>
            </Box>
          </Dialog>

        </Box>
      </When>
      <Otherwise>
        <div className={'Loading'}>
          <Spinner style={{marginTop: 200}}>Chargement...</Spinner>
        </div>
      </Otherwise>
    </Choose>
    <Footer style={{zIndex: 189, marginTop: -10}} footerContent={i18n.get('homeFooterContent', {pretty: true})} showMenu={false} showCopyRight={false}/>
  </div>);
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    // isLoggedIn: isLoggedIn(state),
    // userRole: getCurrentUserRole(state),
    // $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.home}))},
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Home)));



// WEBPACK FOOTER //
// ./src/components/HomeOestro/HomeOestro.jsx